import {
  CreativeInfoItem,
  CreativeInsightsImportanceData,
  Importance
} from '@blisspointmedia/bpm-types/dist/Creative';

export type ConceptMap = Record<string, Set<string>>;

export const CONCEPT_ATTRIBUTE = 'Concept';
export const LANGUAGE_ATTRIBUTE = 'Language';
export const NOT_PRESENT_TAG = 'Not Present';
export const B2B_CONCEPT = 'B2B';

export const RawDataType = {
  ATTRIBUTE: 'attribute',
  TAG: 'tag'
} as const;
export type RawDataTypeType = (typeof RawDataType)[keyof typeof RawDataType];

export const RAW_DATA_VALUE_NUMBER_FORMAT = '0.0#########';

// Sorts ranges without an end date after every dated range.
export const MISSING_END_DATE = '1950-01-01';

// The demo company has no data of its own. Its requests go to a real company and the page
// replaces the responses with the fixtures in creative-insights-demo-data.ts.
export const TEST_COMPANY = 'tinuititest';
export const TEST_COMPANY_PROXY = 'homechef';

export interface EnabledKpis {
  viewableKpis: string[];
  internalKpis: Set<string>;
}

export interface ImportanceData {
  attributeImportanceData: Importance[];
  tagImportanceData: Record<string, Importance[]>;
  attributeTypeBinomial: Record<string, boolean>;
  lastModified: string;
}

export interface ImportanceResponse {
  creativeInsights: CreativeInsightsImportanceData;
  attributeTypeBinomial: Record<string, boolean>;
  lastModified: string | null;
}

export interface ConceptOptions {
  conceptData: { concept: string; categories: Record<string, boolean> }[];
}

export interface Selection {
  attribute: string;
  tag: string;
  creativeKey: string;
}

export const EMPTY_SELECTION: Selection = { attribute: '', tag: '', creativeKey: '' };

export const SelectionActionType = {
  TOGGLE_ATTRIBUTE: 'toggleAttribute',
  SELECT_ATTRIBUTE: 'selectAttribute',
  CLEAR_ATTRIBUTE: 'clearAttribute',
  TOGGLE_TAG: 'toggleTag',
  SELECT_TAG: 'selectTag',
  CLEAR_TAG: 'clearTag',
  SELECT_CREATIVE: 'selectCreative'
} as const;

export type SelectionAction =
  | { type: typeof SelectionActionType.TOGGLE_ATTRIBUTE; attribute: string }
  | { type: typeof SelectionActionType.SELECT_ATTRIBUTE; attribute: string }
  | { type: typeof SelectionActionType.CLEAR_ATTRIBUTE }
  | { type: typeof SelectionActionType.TOGGLE_TAG; tag: string }
  | { type: typeof SelectionActionType.SELECT_TAG; tag: string }
  | { type: typeof SelectionActionType.CLEAR_TAG }
  | { type: typeof SelectionActionType.SELECT_CREATIVE; creativeKey: string };

export interface CreativeInsightsData {
  attributeImportanceData: Importance[];
  tagImportanceData: Record<string, Importance[]>;
  attributeTypeBinomial: Record<string, boolean>;
  suppressedAttributes: Set<string>;
  fillColors: Map<string, string>;
  creativeInfoList: CreativeInfoItem[];
}
